import { DocumentServicesObject } from '@wix/document-services-types';
import { sdkEventHandlersStore } from '../sdkEventHandlersStore/sdkEventHandlersStore';
import { platformEvents } from '../../../../../platformEvents';

export interface AppRefreshService {
  addAppToRefresh: (appDefinitionIds: string[]) => Promise<void>;
  refreshVisitedApps: () => Promise<void>;
}

let resolveAppRefreshServices: (value: AppRefreshService) => void;

const appRefreshServiceServicesPromise = new Promise<AppRefreshService>(
  (resolve) => {
    resolveAppRefreshServices = resolve;
  },
);

export async function getAppRefreshServices() {
  return appRefreshServiceServicesPromise;
}

export const createAppRefreshService = (
  documentServicesAPI: DocumentServicesObject,
): AppRefreshService => {
  const refreshAppComps = (appDefinitionIds: string[]) => {
    const appComps =
      // @ts-expect-error - The method is not defined in the type definition
      documentServicesAPI.tpaV2.app.getAllComps(appDefinitionIds);
    documentServicesAPI.tpa.app.refreshApp(appComps);
  };

  const refreshAppsLivePreview = (appDefinitionIds: string[]) => {
    documentServicesAPI.platform.livePreview.refresh({
      apps: appDefinitionIds,
      source: 'editorRefreshAppComps',
      shouldFetchData: false,
    });
  };

  const addAppToRefresh = async (appDefinitionIds: string[]) => {
    const appIds = appDefinitionIds.filter(
      (appDefinitionId) =>
        documentServicesAPI.platform.getAppDataByAppDefId(appDefinitionId) !==
        undefined,
    );

    sdkEventHandlersStore.setAppsToRefresh(appIds);

    const BUSINESS_MANAGER_APP_ID = 'business-manager-general-info';

    if (appDefinitionIds.includes(BUSINESS_MANAGER_APP_ID)) {
      sdkEventHandlersStore.setShouldRefreshGeneralInfo(true);
    }
  };

  const notifyAppsVisited = (appDefinitionIds: string[]) => {
    documentServicesAPI.platform.notifyAppsOnCustomEvent(
      platformEvents.factory.appVisitedInDashboard({
        visitedAppDefIds: appDefinitionIds,
      }),
    );
  };

  const refreshVisitedApps = async () => {
    const { appsToRefresh, shouldRefreshGeneralInfo } = sdkEventHandlersStore;

    try {
      if (appsToRefresh.length) {
        refreshAppComps(appsToRefresh);
        refreshAppsLivePreview(appsToRefresh);
        notifyAppsVisited(appsToRefresh);

        sdkEventHandlersStore.clearAppsToRefresh();
      }

      if (shouldRefreshGeneralInfo) {
        // @ts-expect-error - The method is not defined in the type definition
        documentServicesAPI.generalInfo.sitePropertiesInfo.reload();
        sdkEventHandlersStore.setShouldRefreshGeneralInfo(false);
      }
    } catch (error) {
      console.error('Failed to refresh app:', error);
    }
  };

  return {
    addAppToRefresh,
    refreshVisitedApps,
  };
};

export const initAppRefreshService = (
  documentServicesAPI: DocumentServicesObject,
) => {
  const appRefreshService = createAppRefreshService(documentServicesAPI);

  resolveAppRefreshServices(appRefreshService);

  return appRefreshService;
};
